import { Component, Vue } from 'vue-property-decorator';
import WithRender from  './ForgotPassword.html';
import config from "@/settings/config.js";
import _axios from '@/services/axios';

@WithRender
@Component
export default class ForgotPassword extends Vue {
    email:string="";
    
    private forgotPassWordDto = {Email: ""};

    sendPasswordReset()
    {
        this.forgotPassWordDto.Email=this.email;
        _axios.post(config.forgotpassword,this.forgotPassWordDto).then(response=>
            {
             console.log(response.data);
              return window.location.href = '/forgotpasswordsuccess';
            }).catch(err=>{
                console.error(err);
              });       
    }
}
